import React from 'react';
import * as LI from 'lucide-react';
import { howItWorks } from '../mock';

export default function HowItWorks() {
  return (
    <section id="how" className="py-24 bg-[#0a2540] relative overflow-hidden scroll-mt-24">
      <div className="absolute inset-0 opacity-[0.05]" style={{ backgroundImage: 'radial-gradient(#fff 1px, transparent 1px)', backgroundSize: '32px 32px' }}/>
      <div className="absolute -bottom-40 -left-40 h-[400px] w-[400px] rounded-full bg-teal-500/10 blur-3xl"/>

      <div className="relative max-w-7xl mx-auto px-6">
        <div className="max-w-3xl">
          <span className="chip !bg-teal-500/15 !text-teal-300">How it Works</span>
          <h2 className="mt-5 text-4xl md:text-5xl font-bold text-white tracking-tight leading-[1.05]">
            Simple, transparent, <span className="font-serif-display italic text-teal-400">fast</span>
          </h2>
          <p className="mt-5 text-slate-300 text-lg leading-relaxed">
            From enquiry to funds in your account — our process is designed to be as effortless as possible. Four simple steps and you are on your way.
          </p>
        </div>

        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {howItWorks.map((s, i) => {
            const Icon = LI[s.icon];
            const isLast = i === howItWorks.length - 1;
            return (
              <div key={s.step} className={`relative ${!isLast ? 'lg:step-line' : ''}`}>
                <div className="bg-white/[0.04] backdrop-blur-sm border border-white/10 rounded-2xl p-6 h-full hover:bg-white/[0.07] hover:border-teal-400/40 transition-all">
                  <div className="flex items-center justify-between">
                    <div className="h-12 w-12 rounded-xl bg-teal-500/15 flex items-center justify-center text-teal-400">
                      {Icon && <Icon size={22}/>}
                    </div>
                    <span className="text-4xl font-bold text-white/10">{s.step}</span>
                  </div>
                  <h4 className="mt-6 text-lg font-semibold text-white">{s.title}</h4>
                  <p className="mt-2 text-sm text-slate-400 leading-relaxed">{s.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
